import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';
import './i18n'; // Sprint 10.3: Initialize i18n before first render
import { initWebVitals } from './utils/webVitals';
import { useThemeStore } from './stores/themeStore';

// Initialize Web Vitals performance monitoring (Sprint 31)
// Batched reporting reduces network overhead while maintaining observability
initWebVitals({ immediate: false });

// Initialize theme from localStorage/system preference (Sprint 31)
// Apply theme before first render to prevent flash of wrong theme
useThemeStore.getState().initFromStorage();

// Configure React Query with sensible defaults for a CA management app
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: 30 seconds - certificates change infrequently
      staleTime: 30 * 1000,
      // Cache time: 5 minutes
      gcTime: 5 * 60 * 1000,
      // Retry failed requests once
      retry: 1,
      // Don't refetch on window focus for admin dashboard
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
